import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../auth/_guards/auth.guard';
import { ThemeComponent } from './theme.component';

const routes: Routes = [
  {
    path: '',
    component: ThemeComponent,
    children: [
      {
        path: 'mi-casillero',
        loadChildren: () =>
          import('./pages/default/mi-casillero/mi-casillero-lista/mi-casillero-lista.module').then(
            (m) => m.MiCasilleroListaModule,
          ),
        canActivate: [AuthGuard],
      },
      { path: '', redirectTo: 'mi-casillero', pathMatch: 'full' },
      {
        path: 'perfil',
        loadChildren: () =>
          import('./pages/default/perfil/perfil-lista/perfil-lista.module').then((m) => m.PerfilListaModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'notificaciones/:id',
        loadChildren: () =>
          import('./pages/default/notificacion/notificacion.module').then((m) => m.NotificacionModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'contacto',
        loadChildren: () => import('./pages/default/contacto/contacto.module').then((m) => m.ContactoModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'tracks',
        loadChildren: () =>
          import('./pages/default/tracks/tracks-list/tracks-list.module').then((m) => m.TracksListModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'tutorial',
        loadChildren: () => import('./pages/default/tutorial/tutorial.module').then((m) => m.TutorialModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'tracks/crear',
        loadChildren: () =>
          import('./pages/default/tracks/crear-track/crear-track.module').then((m) => m.CrearTrackModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'faqs',
        loadChildren: () => import('./pages/default/preguntas/preguntas.module').then((m) => m.PreguntasModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'calculadora',
        loadChildren: () =>
          import('./pages/default/calculadora/calculadora.module').then((m) => m.CalculadoraModule),
        canActivate: [AuthGuard],
      },
      {
        // /membresia/pago vive en AppRoutingModule (sin sesión ni layout).
        path: 'membresia',
        loadChildren: () => import('./pages/default/membresia/membresia.module').then((m) => m.MembresiaModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'facturas',
        loadChildren: () =>
          import('./pages/default/facturaciones/facturaciones-lista/facturaciones-lista.module').then(
            (m) => m.FacturacionesListaModule,
          ),
        canActivate: [AuthGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ThemeRoutingModule {}
